const HeroSection = () => {
  return (
    <section className="px-0 md:px-10 pt-6 pb-10 text-text ">
      {/* Top Info Bar */}
      <div className="mb-6">
        <div className="text-sm text-gray-500 mb-1">
          Home &gt; Hair Salons &gt; Sydney &gt; Woollahra &gt;{" "}
          <span className="text-text font-medium">Willomina</span>
        </div>

        <div className="flex flex-wrap items-center justify-between">
          <h1 className="text-3xl font-bold text-white flex items-center gap-2">
            Willomina
            <span className="text-blue-500">✔️</span>
          </h1>

          <div className="text-sm mt-2 md:mt-0 text-text flex flex-wrap gap-4 items-center">
            <span className="flex items-center gap-1">
              ⭐ 5.0 <span className="text-blue-600">(1,918)</span>
            </span>
            <span className="text-green-600">● Open until 8:00 pm</span>
            <span>● 107 Queen Street, Woollahra</span>
            <a
              href="#"
              className="text-blue-600 underline hover:text-blue-800 transition"
            >
              Get directions
            </a>
          </div>
        </div>
      </div>

      {/* Photo Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Main Large Image */}
        <div className="md:col-span-2 h-[320px] md:h-[460px]">
          <img
            src="https://globalmira.s3.ap-southeast-2.amazonaws.com/rolliciouscover2.jpg"
            alt="Main salon view"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Side Small Images */}
        <div className="flex flex-col gap-4">
          <img
            src="https://images.pexels.com/photos/33062501/pexels-photo-33062501.jpeg"
            alt="Sink area"
            className="h-[150px] md:h-[220px] object-cover rounded-xl w-full"
          />
          <div className="relative">
            <img
              src="https://images.pexels.com/photos/19141514/pexels-photo-19141514.jpeg"
              alt="Seating"
              className="h-[150px] md:h-[220px] object-cover rounded-xl w-full"
            />
            <button className="absolute bottom-2 right-2 bg-white text-black text-sm font-medium px-3 py-1 rounded shadow hover:shadow-md transition">
              See all images
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
